import { predictionMap } from '@app/modules/Messages/Components/UtilityBillAICheckResults/CheckResults/helper/predictionMap'
import { UtilityBillAnalysisChecks } from '@app/modules/Messages/Components/UtilityBillAICheckResults/types'
import { formatNumber } from '@app/modules/Messages/Components/UtilityBillAICheckResults/utils'

// data gets prepared in .csv style to be pasted in the NKA tool that is based on Google sheets
export const prepareResultsForClipboard = (check: UtilityBillAnalysisChecks['invoiceItems']) => {
  return check.children
    .map((item) => {
      return (
        item.context.item +
        ';' +
        (item.context.prediction ? predictionMap[item.context.prediction] : '-') +
        ';' +
        (item.context.distribution?.key ?? '-') +
        ';' +
        formatNumber(item.context.amount)
      )
    })
    .join('\n')
}
